module.exports = __webpack_public_path__ + "static/media/dino-game.54e27d6a.gif";